import React from "react";
import bgImg from "../../resources/umokkurbackground.jpeg";

export const UmOkkur = () => {
  return (
    <div className="min-h-screen bg-[#F5E4CA] flex flex-col md:flex-row">

      {/* Image panel */}
      <div className="w-full md:w-1/2 md:min-h-screen flex-shrink-0 relative">
        <img
          src={bgImg}
          alt="Kallabakarí"
          className="w-full h-64 md:h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/20" />
      </div>

      {/* Content panel */}
      <div className="flex-1 flex flex-col justify-center px-8 py-16 md:px-16">
        <h1 className="font-serif text-stone-900 text-3xl md:text-4xl mb-3">Fyrirtækið Okkar</h1>
        <div className="w-12 h-0.5 bg-[#C29979] mb-8"></div>
        <p className="font-serif text-stone-600 text-base md:text-lg leading-relaxed mb-6">
          Kallabakarí (áður Brauða og kökugerðin) var staðsett á Suðurgötunni á
          Akranesi í rúmlega 50 ár. Það var stofnað árið 1967 af Alfreð Franz
          Karlssyni og síðan rekið af syni hans Karli Ó. Alfreðssyni.
        </p>
        <p className="font-serif text-stone-600 text-base md:text-lg leading-relaxed">
          Núverandi eigendur er þau Alfreð Freyr Karlsson og Valdís Kvaran. Þau fluttu
          bakaríið árið 2018 á núverandi stað að Innnesvegi 1 og reka þau
          fyrirtækið með dyggri aðstoð strákana sinna, þeirra Almars Geirs, Karls
          Ívars og Daða Más.
        </p>
        <div className="mt-10 pt-8 border-t border-amber-100 grid grid-cols-2 gap-6">
          <div>
            <p className="text-xs font-semibold text-[#C29979] uppercase tracking-widest mb-1">Stofnað</p>
            <p className="font-serif text-stone-800 text-lg">1967</p>
          </div>
          <div>
            <p className="text-xs font-semibold text-[#C29979] uppercase tracking-widest mb-1">Staðsetning</p>
            <p className="font-serif text-stone-800 text-lg">Innnesvegur 1, Akranes</p>
          </div>
        </div>
      </div>

    </div>
  );
};

export default UmOkkur;
